import { Layout } from '@loadsmart/miranda-react'

import { type AgnosticShipmentFilter } from '../../../domain/AgnosticShipmentFilter'
import { type useGetShipmentsMetadata } from '../../hooks/useGetShipmentsMetadata'
import { type FilterEntrypoint, type FilterKey } from '../ShipmentsMetadata'
import { ShipmentsMetadataItem } from './ShipmentsMetadataItem'

type ShipmentsMetadataDesktopViewProps = {
  filters: AgnosticShipmentFilter
  isUnreadChatEnabled?: boolean
  shipmentsMetadata: ReturnType<typeof useGetShipmentsMetadata>['shipmentsMetadata']
  totalShipments: number
  onFilterClick: (filterKey?: FilterKey, entrypoint?: FilterEntrypoint) => void
}

export function ShipmentsMetadataDesktopView({
  filters,
  isUnreadChatEnabled,
  shipmentsMetadata,
  totalShipments,
  onFilterClick,
}: ShipmentsMetadataDesktopViewProps) {
  return (
    <Layout.Switcher
      paddingT="spacing-2"
      paddingB="spacing-4"
      gap="spacing-4"
      threshold="200px"
      limit={isUnreadChatEnabled ? 4 : 3}
    >
      <ShipmentsMetadataItem
        active={filters.pendingAppointments}
        title="Pending appointments"
        value={shipmentsMetadata?.pendingAppointments ?? 0}
        totalShipments={totalShipments}
        onClick={() => onFilterClick('pendingAppointments', 'summaryCard')}
      />
      <ShipmentsMetadataItem
        active={filters.missingPods}
        title="Missing pods"
        value={shipmentsMetadata?.missingPods ?? 0}
        totalShipments={totalShipments}
        onClick={() => onFilterClick('missingPods', 'summaryCard')}
      />
      <ShipmentsMetadataItem
        active={filters.missingInvoices}
        title="Missing invoices"
        value={shipmentsMetadata?.missingInvoices ?? 0}
        totalShipments={totalShipments}
        onClick={() => onFilterClick('missingInvoices', 'summaryCard')}
      />
      {isUnreadChatEnabled && (
        <ShipmentsMetadataItem
          active={filters.unreadChat}
          title="Unread chat messages"
          value={shipmentsMetadata?.unreadChat ?? 0}
          totalShipments={totalShipments}
          onClick={() => onFilterClick('unreadChat', 'summaryCard')}
        />
      )}
    </Layout.Switcher>
  )
}
